export default __webpack_public_path__ + "static/airbnb.url-d1de2d301b4bc146fbe08d60d93556ff.svg";